<style lang="scss" scoped>
.actions {
	margin-left: auto !important;
}
</style>
<template lang="pug">
div
	org-app-header
		template(slot='header')
			.d-flex
				h1 Settings
				el-button(type='primary', :loading='loading', @click='save', e2e="settings").actions {{ loading ? "Saving settings..." : "Save settings" }}
	settings(ref="settings_form" v-on:Saving="loading = $event", :isOrg="true")
</template>
<script>
import Settings from "./../../../components/Settings";
export default {
	components: {
		Settings
	},
	data() {
		return {
			loading: false
		};
	},
	methods: {
		save() {
			this.$refs.settings_form.save();
		}
	}
};
</script>